export default __webpack_public_path__ + "static/media/Close.2cf33328.svg";